module.exports = __webpack_public_path__ + "img/ETHNIC NECKLACE RED.4390486.svg";